import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { useTranslation } from 'react-i18next';
import { DescriptionTable, JsonView } from 'shared/components';
import { displayValue } from 'shared/helpers';

const CustomerAccountDetails = ({ account }) => {
  const { t } = useTranslation();

  const getAccountPhone = (value) =>
    get(value, 'phone_number') || get(value, 'phone');

  const getAccountAddress = (value) => {
    const address = get(value, 'address');
    if (address) {
      return address;
    }

    const parts = [
      get(value, 'address_line1'),
      get(value, 'address_line2'),
      get(value, 'city'),
      get(value, 'state'),
      get(value, 'country'),
      get(value, 'zipcode') || get(value, 'postcode'),
    ].filter(Boolean);

    return parts.length ? parts.join(', ') : null;
  };

  return (
    <div className="CustomerAccountDetails">
      <DescriptionTable
        details={[
          { label: t('Code'), value: displayValue(get(account, 'code')) },
          {
            label: t('Reference'),
            value: displayValue(get(account, 'reference')),
          },
          { label: t('Name'), value: displayValue(get(account, 'name')) },
          {
            label: t('Description'),
            value: displayValue(get(account, 'description')),
          },
          { label: t('Email'), value: displayValue(get(account, 'email')) },
          {
            label: t('Address'),
            value: displayValue(getAccountAddress(account)),
          },
          {
            label: t('Phone Number'),
            value: displayValue(getAccountPhone(account)),
          },
          {
            label: t('Metadata'),
            value: (
              <JsonView value={get(account, 'metadata')} name="metadata" />
            ),
          },
        ]}
      />
    </div>
  );
};

CustomerAccountDetails.propTypes = {
  account: PropTypes.object.isRequired,
};

export default CustomerAccountDetails;
